

















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import FooterSitemapItem from '@/webcomponents/footer-sitemap/FooterSitemapItem.vue';
import IntersectionDirective from '@/common/vue/intersection-directive';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import ParentComponentMixin from '@/common/ts/child-component/ParentComponentMixin';
import BackgroundColorMixin from '@/common/ts/background-color/BackgroundColorMixin';

const WordFade = () => import('@/common/vue/WordFade.vue');

const FooterSitemapProps = Vue.extend({
  props: {
    headlineText: String,
    editMode: Boolean,
    pageOpenedInEditMode: Boolean,
  },
});
@Component({
  components: {
    WordFade,
  },
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class FooterSitemap extends mixins(FooterSitemapProps, ParentComponentMixin, BackgroundColorMixin) {
  items: ChildComponentCollection<FooterSitemapItem> = new ChildComponentCollection<FooterSitemapItem>();
  isShown = false;

  created () {
    this.initParentComponentMixin(
      this.items,
      ['FooterSitemapItem'],
    );
  }

  fadeInItems () {
    this.items.items.forEach((item) => {
      item.fadeIn = true;
    });
  }

  handleIntersection (isIntersecting: boolean) {
    if (isIntersecting) {
      this.fadeInItems();
    } else {
      this.fadeOut();
    }
  }

  // for experience fragment in aem: edit-mode is not active for the component in the experience
  // fragment but we are currently still in the author view and have to apply the same behaviour
  // as for edit-mode
  get editModeOrPageOpenedInEditMode (): boolean {
    return this.editMode || this.pageOpenedInEditMode;
  }

  get rootClass () {
    return {
      'brandhub-footer-sitemap--edit-mode': this.editModeOrPageOpenedInEditMode,
      'brandhub-footer-sitemap--show': this.isShown,
    };
  }

  fadeIn () {
    this.fadeInItems();
    this.isShown = true;
  }

  fadeOut () {
    this.items.items.forEach((item) => {
      item.fadeIn = false;
    });
    this.isShown = false;
  }
}
